<script setup lang="ts">
  interface Props {
    title?: string;
    description?: string;
    mdiIcon?: string;
    svgIcon?: string;
    isLibrary?: boolean;
    search?: string;
    showSearch?: boolean;
    isComplete?: boolean;
    showPlans?: boolean; // 講座一覧を表示するかどうか
    enableAllPlan?: boolean; // 講座一覧に全ての講座を表示するかどうか
    defaultPlanId?: string; // 講座一覧のデフォルトの講座ID
    loading?: boolean; // 講座一覧のローディング状態
  }
  const localProps = withDefaults(defineProps<Props>(), {
    title: "",
    description: "",
    mdiIcon: "",
    svgIcon: "",
    isLibrary: false,
    search: "",
    showSearch: false,
    isComplete: false,
    showPlans: false,
    enableAllPlan: true,
    defaultPlanId: undefined,
    loading: true,
  });

  interface Emit {
    (event: "onBack"): void;
    (event: "update:search", search: string): void;
  }
  const emit = defineEmits<Emit>();

  const searchModel = computed<string>({
    get: () => localProps.search ?? "",
    set: (value: string) => {
      emit("update:search", value);
    },
  });

  const isSp = isSpDisplayRef();

  // ヘッダーの高さによってメッセージエリアの高さを調整する
  const headerAreaRef = ref<HTMLDivElement | undefined>(undefined);
  const { height: headerAreaElementHeight } = useElementBounding(headerAreaRef);
  const contentAreaHeight = computed<string>(() => {
    if (headerAreaElementHeight.value) return `calc(100% - ${headerAreaElementHeight.value}px)`;
    return "calc(100% - 60px)";
  });
</script>

<template>
  <MoleculesContainerMainHeader
    ref="headerAreaRef"
    v-model:search="searchModel"
    :title="!isSp && showPlans ? '' : title"
    :description="!isSp && showPlans ? '' : description"
    :svg-icon="!isSp && showPlans ? '' : svgIcon"
    :mdi-icon="!isSp && showPlans ? '' : mdiIcon"
    :is-library="isLibrary"
    :show-search="showSearch"
    :is-complete="isComplete"
    @on-back="$emit('onBack')"
  >
    <template #header-title>
      <slot name="header-title">
        <MoleculesContainerMainPlan
          v-if="!isSp && showPlans"
          :enable-all-plan="enableAllPlan"
          :default-plan-id="defaultPlanId"
          :loading="loading"
        />
      </slot>
    </template>
    <template #header-btns>
      <slot name="header-btns"></slot>
    </template>
    <template #header-extra>
      <slot name="header-extra"></slot>
    </template>
    <template #header-main-extra>
      <slot name="header-main-extra">
        <div v-if="isSp && showPlans" class="header-main-extra">
          <MoleculesContainerMainPlan
            :enable-all-plan="enableAllPlan"
            :default-plan-id="defaultPlanId"
            :loading="loading"
          />
        </div>
      </slot>
    </template>
  </MoleculesContainerMainHeader>
  <div class="content_list_wrapper" :class="{ 'is-library': isLibrary }">
    <slot></slot>
  </div>
</template>

<style lang="scss" scoped>
  @import "assets/media.scss";
  .content_list_wrapper {
    overflow-y: scroll;
    overflow-x: scroll;
    height: v-bind("contentAreaHeight");
    position: relative;
    // スクロールバーを非表示にする (以下の一式でクロスブラウザ対応)
    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
    &.is-library {
      padding: 20px;
      @include display_sp {
        padding: 10px 10px 10px 4px;
      }
    }
  }
  .header-main-extra {
    padding: 10px 10px 10px 10px;
    border-bottom: 1px solid rgb(var(--v-theme-monochrome-08));
  }
</style>
